import { render, staticRenderFns } from "./TheDetail.vue?vue&type=template&id=5d6afb6a&scoped=true&lang=pug&"
import script from "./TheDetail.vue?vue&type=script&lang=js&"
export * from "./TheDetail.vue?vue&type=script&lang=js&"
import style0 from "./TheDetail.vue?vue&type=style&index=0&id=5d6afb6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d6afb6a",
  null
  
)

export default component.exports